// extracted by mini-css-extract-plugin
module.exports = {"favoriteButtonMobile":"style-module__favoriteButtonMobile___1ywac","favoriteButtonDesktop":"style-module__favoriteButtonDesktop___3vEGj"};